import { render, staticRenderFns } from "./imgAndServe.vue?vue&type=template&id=9b6be528&scoped=true&"
import script from "./imgAndServe.vue?vue&type=script&lang=js&"
export * from "./imgAndServe.vue?vue&type=script&lang=js&"
import style0 from "./imgAndServe.vue?vue&type=style&index=0&id=9b6be528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6be528",
  null
  
)

export default component.exports